<template>
    <div class="v-flex">
        <!-- Filter menu -->
        <crm-entry-filter-menu
            @filter = "onFilter"
        />
        <!-- Filter menu -->

        <!-- Dropdown to create new entries -->
        <v-btn
            color  = "white"
            class  = "menu-button primary--text ml-1"
            @click = "onEdit"
            dark
            depressed
        >
            <span>{{ $t('crm.title') }}</span>
            <i class="fas fa-caret-down ml-1" :class="{'menu-open':menu}"></i>
        </v-btn>
        <!-- Dropdown to create new entries -->

        <v-scale-transition>
            <v-card
                v-if      = "menu"
                elevation = "0"
                class     = "crm-edit-container pa-0 mt-2"
            >
                <div style="height: 630px; background-color: white">
                    <v-tabs
                        v-model = "tabs"
                        class   = "crm-tabs"
                        left
                    >
                        <v-tab class="crm-tab">
                            <v-icon>fas fa-phone</v-icon>
                        </v-tab>
                        <v-tab class="crm-tab">
                            <v-icon>far fa-comment</v-icon>
                        </v-tab>
                        <v-tab class="crm-tab">
                            <v-icon>far fa-bell</v-icon>
                        </v-tab>
                        <div class="crm-card-filler"></div>
                    </v-tabs>

                    <v-tabs-items v-model="tabs">
                        <v-tab-item>
                            <crm-entry-tab-item
                                :incident  = "incident"
                                :entry     = "createEntry(type.phone)"
                                ref        = "crmtab"
                                @saved     = "onSaved"
                                @cancel    = "onCancel"
                            />
                        </v-tab-item>

                        <v-tab-item>
                            <crm-entry-tab-item
                                :incident  = "incident"
                                :entry     = "createEntry(type.notice)"
                                ref        = "crmtab"
                                @saved     = "onSaved"
                                @cancel    = "onCancel"
                            />
                        </v-tab-item>

                        <v-tab-item>
                            <crm-entry-tab-item
                                :incident  = "incident"
                                :entry     = "createEntry(type.reminder)"
                                ref        = "crmtab"
                                @saved     = "onSaved"
                                @cancel    = "onCancel"
                            />
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </v-card>
        </v-scale-transition>
    </div>
</template>

<script>

import Inc                from "@/modules/inc/service/Inc.js";
import Crm                from "@/modules/crm/service/Crm.ts";
import CrmEntryTabItem    from "@/modules/crm/components/main/CrmEntryTabItem";
import CrmEntryFilterMenu from "@/modules/crm/components/main/CrmEntryFilterMenu.vue";

export default {
    name: "CrmEntryEditTab",
    props: {
        incident: {
            required: true,
            type    : Object
        }
    },

    components: {
        CrmEntryFilterMenu,
        CrmEntryTabItem,
    },

    data() {
        return {
            menu: false,
            tabs: null,
            date: null,
            edit: false,
            type: Crm.journal.type,
        }
    },

    watch: {
        restoreNotices: function () {
            this.$bus.$emit(Inc.events.journal);
        },
    },

    computed: {
        preferences() {
            return this.$store.getters.preferences;
        },

        restoreNotices () {
            return this.$store.getters.preferences.restoreNotices;
        },
    },

    methods: {
        onEdit () {
            this.menu = !this.menu;
            this.$emit(Crm.events.edit, null);
        },

        onSaved () {
            this.$emit(Crm.events.saved);
            this.menu = false;
            this.refresh();
        },

        onDeleted () {
            this.$emit(Crm.events.deleted);
            this.menu = false;
        },

        onFilter (filter) {
            this.$emit("filter", filter)
        },

        onCancel () {
            this.menu = false;
        },

        createEntry (type) {
            return JSON.parse(JSON.stringify({
                id         : null,
                time       : null,
                frequency  : 1,
                subject    : null,
                description: null,
                type       : {
                    id: type,
                },
                incident: {
                    id: null,
                    site: {
                        id: null
                    }
                },
                partner: {

                }
            }));
        },

        refresh () {
            this.$bus.$emit(Inc.events.journal);
        }
    },
}
</script>

<style scoped>

.crm-card-filler {
    width: 100%;
    border-bottom-color: lightgray;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    margin-bottom: 13px;
    font-weight: normal;
}

.crm-edit-container {
    padding: 10px;
    width: 100%;
    position: absolute;
    z-index: 10;
}

.crm-tabs {
    height: 40px;
}

.crm-tab {
    padding-left: 0;
    padding-right: 0;
    min-width: 45px;
    max-width: 45px;
    max-height: 35px;
    border-style: solid;
    border-color: lightgray;
    border-width: 1px;
    border-bottom-style: none;

    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
}

.crm-tab:not(.v-tab--active) {
    border-bottom-color: lightgray;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-left-style: none;
    border-right-style: none;
    border-top-style: none;
}

.crm-textarea div {
    background-color: purple !important;
    border-style: solid;
    border-color: lightgray;
    border-width: 1px;
    padding: 1.5rem 0;
}

::v-deep .v-btn:not(.v-btn--text):not(.v-btn--outlined):focus:before {
    opacity: 0;
}

::v-deep .v-menu__content {
    box-shadow: none;
}

.menu-open {
    transform: rotate(180deg) translate(0px);
    -webkit-transition: all 150ms ease-in 0s;
    transition: all 150ms ease-in 0s;
}

</style>